import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Typography } from '@mui/material';

const ModalUpdateAppPassword = ({ open, onClose, onConfirm, appName, payload, setPayload, isLoading }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="update-app-password-title"
      PaperProps={{
        sx: {
          borderRadius: 3,
          border: '1px solid var(--border-subtle)',
          boxShadow: 'var(--shadow-card)',
          p: 1,
        },
      }}
    >
      <DialogTitle id="update-app-password-title" sx={{ fontWeight: 700, pb: 1 }}>
        Update Password{appName ? `: ${appName}` : ''}
      </DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        <Typography variant="body2" className="muted-text" sx={{ mt: 1 }}>
          Masukkan kredensial baru untuk aplikasi yang dipilih.
        </Typography>
        <TextField
          margin="normal"
          required
          fullWidth
          id="app-username"
          label="Username/NIK/Email (Aplikasi)"
          name="username"
          autoComplete="username"
          value={payload.username}
          onChange={(e) => setPayload({ ...payload, username: e.target.value })}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password Baru (Aplikasi)"
          type="password"
          id="app-password"
          autoComplete="new-password"
          value={payload.password}
          onChange={(e) => setPayload({ ...payload, password: e.target.value })}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button onClick={onClose} color="primary" variant="outlined" disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained" autoFocus disabled={isLoading}>
          {isLoading ? 'Updating...' : 'Submit'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalUpdateAppPassword;
